import { render, staticRenderFns } from "./DetailsPrice.vue?vue&type=template&id=48ea460d"
import script from "./DetailsPrice.vue?vue&type=script&lang=ts"
export * from "./DetailsPrice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports